export const ResourceConstant = {
  viewPermission: 'anonymous',
  loadPermission: 'anonymous'
  // viewPermission: 'FB_Design_Forms',
  // loadPermission: 'FB_Design_Forms',

  // 'anonymous' only be using for test replace with you string permision from Control Tower Security
  // Tech Lead or DevOps Lead can configure here - https://controltowert.iso.com/mm/#/security/resources/resourceList
};

export const QuestionEditorResourceConstant = {
  viewPermission: 'FB_Dev_Forms',
  loadPermission: 'FB_Dev_Forms',
};

export const FormReviewerResourceConstant = {
  viewPermission: 'FB_Approve_Forms',
  loadPermission: 'FB_Approve_Forms',
};

export const AdminResourceConstant = {
  // viewPermission: 'FB_Admin_Forms',
  // loadPermission: 'FB_Admin_Forms',
  viewPermission: 'anonymous',
  loadPermission: 'anonymous'  
};
export const PinpointSupportResourceConstant = {
  viewPermission: 'FB_PPNT_SUPPORT',
  loadPermission: 'FB_PPNT_SUPPORT',
};